import { t } from "@lingui/macro";
import { DataTable } from "@src/components/ui-kit";
import { getMonths } from "@src/config/constants";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import type { Store } from "./Store";

interface SummaryBoxProps {
  period?: {
    month: number;
    year: number;
  };
  summary: Store["summary"];
  isLoaded: boolean;
}

export const SummaryBox: FunctionComponent<SummaryBoxProps> = observer(
  function SummaryBox({ period, summary, isLoaded }) {
    const { progress_change, progress_change_billable } = summary ?? {
      progress_change: 0,
      progress_change_billable: 0,
    };

    return (
      <DataTable.SummaryBox
        label={
          <div style={{ width: 250 }}>
            {period && `${getMonths()[period.month]} ${period.year} stats`}
          </div>
        }
        justify="space-around"
      >
        <DataTable.SummaryItem
          label={t`Progress change`}
          labelTooltip={t`Including non-billable projects.`}
          isLoaded={isLoaded}
        >
          {currency.formatByWorkspace(progress_change)}
        </DataTable.SummaryItem>

        <DataTable.SummaryItem
          label={t`Progress change (excluding non-billable)`}
          isLoaded={isLoaded}
        >
          {currency.formatByWorkspace(progress_change_billable)}
        </DataTable.SummaryItem>
      </DataTable.SummaryBox>
    );
  },
);
